import { useState } from "react";
import { Link } from "react-router-dom";
import MenuToggler from "./MenuToggler";
import "../styles/nav.css";
import Button from "./Button";

const Header = () => {
  const links = [
    "Home",
    "About",
    "Menu",
    "Reservations",
    "Order Online",
  ];
  const [menuExpanded, setMenuExpanded] = useState(false);

  return (
    <header role="banner" className="doc-header">
      <nav className="nav">
        <Link to={"/"}>
          <img className="logo" src="img/Logo.svg" alt="Little Lemon Logo" />
        </Link>

        <MenuToggler
          menuExpanded={menuExpanded}
          setMenuExpanded={setMenuExpanded}
        />

        <div className="overlay" aria-hidden="true"></div>

        <ul className="nav-list">
          {links.map((link) => (
            <li>
              <Link to={link === "Home" ? "/" : link === "Order Online" ? "/order-onine" : "/" + link.toLocaleLowerCase()}>
                {link}
              </Link>
            </li>
          ))}
          <li>
            <Button>Login</Button>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Header;
